import { createContext } from 'react';

const ReporterServiceContext = createContext(null);

export default ReporterServiceContext;
